import React, {useState} from 'react';
import {Col, Row} from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAward} from '@fortawesome/free-solid-svg-icons';
import styles from '../../styles/compare/OfferInfo.module.scss';
import withFullPopup from '../../elements/withFullPopup';
import BCTerms from './BCTerms';

const BCTeaser = () => {
    const [isOpen, editIsOpen] = useState(false);
    const openTerms = () => {editIsOpen(true)}
    const closeTerms = () => {editIsOpen(false)}

    const Terms = withFullPopup(BCTerms);

    return (
        <Row className={`pt-3 ${styles.bcTeaser}`}>
            <Col className="d-flex align-items-center"  >
                <FontAwesomeIcon icon={faAward} width="16" height="16" size="2x" className="me-3 green"/>
                <div>
                    Aplică la un credit pe Conso și îți poți consulta gratuit situația de la Biroul de Credit. <span onClick={openTerms} className={styles.link}>Condiții</span>
                </div>
            </Col>
            {isOpen && 
                <Terms 
                    title="Condiții de acces la situația de la Biroul de Credit"
                    closePopup={closeTerms}
                    close={closeTerms}
                />
            }
        </Row>
    );
}

export default BCTeaser;

